import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CURRENT_USER_PLATFORM_IDENTITY = new InjectionToken<Observable<string>>(
  'CURRENT_USER_PLATFORM_IDENTITY'
);
